import { render } from "./index.vue?vue&type=template&id=3a495aba&scoped=true"
import script from "./index.vue?vue&type=script&lang=js"
export * from "./index.vue?vue&type=script&lang=js"

import "./index.vue?vue&type=style&index=0&id=3a495aba&lang=scss&scoped=true"

import exportComponent from "D:\\消防\\dashboard\\node_modules\\vue-loader-v16\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-3a495aba"],['__file',"src/views/food/order/index.vue"]])
/* hot reload */
if (module.hot) {
  __exports__.__hmrId = "3a495aba"
  const api = __VUE_HMR_RUNTIME__
  module.hot.accept()
  if (!api.createRecord('3a495aba', __exports__)) {
    console.log('reload')
    api.reload('3a495aba', __exports__)
  }
  
  module.hot.accept("./index.vue?vue&type=template&id=3a495aba&scoped=true", () => {
    console.log('re-render')
    api.rerender('3a495aba', render)
  })

}


export default __exports__